import { render, staticRenderFns } from "./vector_point.vue?vue&type=template&id=5179e1c6&scoped=true&"
import script from "./vector_point.vue?vue&type=script&lang=js&"
export * from "./vector_point.vue?vue&type=script&lang=js&"
import style0 from "./vector_point.vue?vue&type=style&index=0&id=5179e1c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179e1c6",
  null
  
)

export default component.exports